import React, { useEffect, useState } from "react";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";  // Import your configured axios instance
import './UsersList.css'; // Import the CSS file
import TopBar from "./TopBar";
import { Container } from "react-bootstrap";
import { useNavigate } from 'react-router-dom'; // Import useNavigate

const ListUsers = () => {
  const navigate = useNavigate();
  const [users, setUsers] = useState([]); // To store list of users
  const [loading, setLoading] = useState(true); // To show loading spinner while fetching
  const [error, setError] = useState(null); // To handle errors
  const [currentPage, setCurrentPage] = useState(1); // Current page for pagination
  const usersPerPage = 15; // Number of users per page
  const axiosPrivate = useAxiosPrivate();
  const USERS_URL = "api/get-users"; // Replace with the correct API endpoint to fetch users

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const response = await axiosPrivate.get(USERS_URL, {
          withCredentials: true, // Ensures cookies are sent with the request if needed
        });
        // setUsers(response.data); // Store the list of users into the state
        if (Array.isArray(response.data)) {
          setUsers(response.data);
        } else if (Array.isArray(response.data?.users)) {
          setUsers(response.data.users);
        } else {
          setUsers([]); // fallback to empty array
        }


        setLoading(false); // Stop loading spinner
      } catch (error) {
        console.error("Error fetching users:", error);
        setError("Failed to load users");
        setLoading(false); // Set loading to false even if there is an error
      }
    };

    fetchUsers();
  }, []);

  // Paginate users
  const indexOfLastUser = currentPage * usersPerPage;
  const indexOfFirstUser = indexOfLastUser - usersPerPage;
  // const currentUsers = users.slice(indexOfFirstUser, indexOfLastUser);
  const currentUsers = Array.isArray(users)
    ? users.slice(indexOfFirstUser, indexOfLastUser)
    : [];


  // Pagination handler
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  // Total pages needed for pagination
  const totalPages = Math.ceil(users.length / usersPerPage);

  if (loading) {
    return <div className="loading">Loading...</div>;
  }

  if (error) {
    return <div className="error">{error}</div>;
  }

  const handleRedirect = () => {
    navigate("/registeruser");
  }
  return (
    <>
      {/* <Container> */}
      <section className="empbody">
        <div className="wrapperemp2">
          <div className="d-flex align-items-center">
            <button
              onClick={() => navigate(-1)}
              className="btn btn-secondary newviewbtn me-2"
            >
              ← Back
            </button>

            <button
              type="button"
              onClick={handleRedirect}
              className="btn btn-success ms-auto top-bt"
            >
              User Registration
            </button>
          </div>

          <h3>User List</h3>
          <table id="customers">
            <thead>
              <tr>
                <th>Name</th>
                <th>Username</th>
                <th>Role</th>
                <th>Email</th>
                <th>Franchise</th>
                <th>Verified</th>
                <th>Last Login</th>
              </tr>
            </thead>
            <tbody>
              {currentUsers.length === 0 ? (
                <tr>
                  <td colSpan="7" style={{ textAlign: "center" }}>
                    No users found
                  </td>
                </tr>
              ) : (
                currentUsers.map((user) => (
                  <tr key={user.id}>
                    <td>{user.name}</td>
                    <td>{user.user_name}</td>
                    <td>{user.role}</td>
                    <td>{user.email}</td>
                    <td>{user.franchise_name}</td>
                    <td>
                      {user.is_verified === 1 ? "Verified" : "Not Verified"}
                    </td>
                    <td>
                      {user.last_login
                        ? new Date(user.last_login).toLocaleString()
                        : "-"}
                    </td>
                  </tr>
                ))
              )}

            </tbody>
          </table>

          {/* Pagination - only show if there are multiple pages */}
          {totalPages > 1 && (
            <div className="pagination">
              {Array.from({ length: totalPages }, (_, index) => (
                <button
                  key={index}
                  onClick={() => handlePageChange(index + 1)}
                  disabled={currentPage === index + 1}
                >
                  {index + 1}
                </button>
              ))}
            </div>
          )}


        </div>
      </section>
      <TopBar />
      {/* </Container> */}

    </>
  );
};

export default ListUsers;
